import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTr = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 8", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#E30A17", d: "M0 0h12v8H0z" }), /* @__PURE__ */ React.createElement("circle", { cx: 4.25, cy: 4, r: 2, fill: "#fff" }), /* @__PURE__ */ React.createElement("circle", { cx: 4.75, cy: 4, r: 1.6, fill: "#e30a17" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M5.83334 4l1.80901 .58779-1.11804-1.53885v1.90212l1.11804-1.53885z" }));
const ForwardRef = forwardRef(SvgTr);
const Memo = memo(ForwardRef);
export default Memo;
